/**
 * @generated SignedSource<<19b97acf1871973e4708670357b0f014>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type DrinkingHabit = "DAILY" | "FOUR_TO_FIVE_PER_WEEK" | "LESS_THAN_ONE_TIMES_PER_WEEK" | "NEVER" | "NOT_SPECIFIED" | "NO_LONGER" | "ONE_TO_THREE_PER_WEEK";
export type SmokingHabit = "IN_COMPANY" | "NEVER" | "NOT_SPECIFIED" | "NO_LONGER" | "REGULARLY";
import { FragmentRefs } from "relay-runtime";
export type SocialHistoryFragment$data = {
  readonly comment: string | null;
  readonly drinkingHabit: DrinkingHabit;
  readonly id: string;
  readonly smokingHabit: SmokingHabit;
  readonly " $fragmentType": "SocialHistoryFragment";
};
export type SocialHistoryFragment$key = {
  readonly " $data"?: SocialHistoryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"SocialHistoryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SocialHistoryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "comment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "drinkingHabit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "smokingHabit",
      "storageKey": null
    }
  ],
  "type": "SocialHistory",
  "abstractKey": null
};

(node as any).hash = "2fe991e396bf56223c90543fef6b1f24";

export default node;
